import { ALLOW_EDIT } from '../../../utils/OperationPermissions';

const PurchaseTransactionEnquiry = {
  type: 'PurchaseTransactionEnquiry',
  formTitle: 'Purchase Transaction Enquiry',
  formUrl: '/Suppliers/TransactionEnquiry/',
  screenReference: 'SUPPLIER_TRANSACTION_ENQUIRY',
  operations: ALLOW_EDIT,
};

export default PurchaseTransactionEnquiry;
